/**
 * Api Portal AutoAtendimento
 * AutoAtendimento
 *
 * OpenAPI spec version: v1
 * Contact: helpdesk@sicred.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
* The ProdutosCdc model module.
* @module model/ProdutosCdc
* @version v1
*/
export default class ProdutosCdc {
    /**
    * Constructs a new <code>ProdutosCdc</code>.
    * @alias module:model/ProdutosCdc
    * @class
    */

    constructor() { }

    /**
    * Constructs a <code>ProdutosCdc</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ProdutosCdc} obj Optional instance to populate.
    * @return {module:model/ProdutosCdc} The populated <code>ProdutosCdc</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProdutosCdc();
            
            if (Object.prototype.hasOwnProperty.call(data, 'empresa')) {
                obj['empresa'] = ApiClient.convertToType(data['empresa'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'produto')) {
                obj['produto'] = ApiClient.convertToType(data['produto'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'iofAtraso')) {
                obj['iofAtraso'] = ApiClient.convertToType(data['iofAtraso'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'diasIofAtraso')) {
                obj['diasIofAtraso'] = ApiClient.convertToType(data['diasIofAtraso'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'tipoCompermanencia')) {
                obj['tipoCompermanencia'] = ApiClient.convertToType(data['tipoCompermanencia'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'moedaCompermanencia')) {
                obj['moedaCompermanencia'] = ApiClient.convertToType(data['moedaCompermanencia'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaMora')) {
                obj['taxaMora'] = ApiClient.convertToType(data['taxaMora'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaDiferenciada')) {
                obj['taxaDiferenciada'] = ApiClient.convertToType(data['taxaDiferenciada'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'ativares4558')) {
                obj['ativares4558'] = ApiClient.convertToType(data['ativares4558'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaMora4558')) {
                obj['taxaMora4558'] = ApiClient.convertToType(data['taxaMora4558'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'restauraLimiteCartao')) {
                obj['restauraLimiteCartao'] = ApiClient.convertToType(data['restauraLimiteCartao'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'diasMulta')) {
                obj['diasMulta'] = ApiClient.convertToType(data['diasMulta'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaMulta')) {
                obj['taxaMulta'] = ApiClient.convertToType(data['taxaMulta'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaAntecipacao')) {
                obj['taxaAntecipacao'] = ApiClient.convertToType(data['taxaAntecipacao'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'diasAntecipacao')) {
                obj['diasAntecipacao'] = ApiClient.convertToType(data['diasAntecipacao'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'tipoProduto')) {
                obj['tipoProduto'] = ApiClient.convertToType(data['tipoProduto'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'taxaCompermanencia')) {
                obj['taxaCompermanencia'] = ApiClient.convertToType(data['taxaCompermanencia'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'nome')) {
                obj['nome'] = ApiClient.convertToType(data['nome'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'boletoPortal')) {
                obj['boletoPortal'] = ApiClient.convertToType(data['boletoPortal'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} agencia
    */
    agencia = undefined;
    /**
    * @member {String} empresa
    */
    empresa = undefined;
    /**
    * @member {String} iofAtraso
    */
    iofAtraso = undefined;
    /**
    * @member {String} diasIofAtraso
    */
    diasIofAtraso = undefined;
    /**
    * @member {String} tipoCompermanencia
    */
    tipoCompermanencia = undefined;
    /**
    * @member {String} moedaCompermanencia
    */
    moedaCompermanencia = undefined;
    /**
    * @member {Number} taxaMora
    */
    taxaMora = undefined;
    /**
    * @member {Number} taxaDiferenciada
    */
    taxaDiferenciada = undefined;
    /**
    * @member {String} ativares4558
    */
    ativares4558 = undefined;
    /**
    * @member {Number} taxaMora4558
    */
    taxaMora4558 = undefined;
    /**
    * @member {String} restauraLimiteCartao
    */
    restauraLimiteCartao = undefined;
    /**
    * @member {Number} diasMulta
    */
    diasMulta = undefined;
    /**
    * @member {Number} taxaMulta
    */
    taxaMulta = undefined;
    /**
    * @member {Number} taxaAntecipacao
    */
    taxaAntecipacao = undefined;
    /**
    * @member {Number} diasAntecipacao
    */
    diasAntecipacao = undefined;
    /**
    * @member {String} tipoProduto
    */
    tipoProduto = undefined;
    /**
    * @member {Number} taxaCompermanencia
    */
    taxaCompermanencia = undefined;
    /**
    * @member {String} nome
    */
    nome = undefined;
    /**
    * @member {String} boletoPortal
    */
    boletoPortal = undefined;
}